import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage } from 'react-intl';
import LeasingCalculatorForm from '../LeasingCalculatorForm/LeasingCalculatorForm';

import s from './LeasingHeader.css';

class LeasingHeader extends React.Component {
  render() {
    return (
      <div className={s.root}>
        <div className={s.bg} />
        <div className={s.title}>
          <FormattedMessage id={'Лизинг авто на avtobazar.ua'} />
        </div>
        <div className={s.description}>
          <FormattedMessage id={'LEASING_HEADER_DESCRPTION'} />
        </div>
        <div className={s.calculationForm}>
          <LeasingCalculatorForm />
        </div>
      </div>
    );
  }
}

export default withStyles(s)(LeasingHeader);



// WEBPACK FOOTER //
// ./src/shared/components/Article/Leasing/LeasingHeader/LeasingHeader.js